import { Collection } from 'modules/core/lib/mobx-rest'

import Form from 'modules/enps/store/models/Form'

class Forms extends Collection<Form> {
  get cacheKey(): string {
    return 'enpsForms'
  }

  model() {
    return Form
  }

  /**
   * Initialize the default eNPS form for the company
   * Creates form if missing, returns existing if present
   */
  setup() {
    return this.rpc('setup')
  }
}

export default new Forms()
